import React from "react";
import {  useParams } from "react-router";

// TODO: Deprecated need to redo
export default function InteractionInfo({
  drawMode,
  modifying,
  isGlobe,
}: {
  drawMode?: string;
  modifying: boolean;
  isGlobe: boolean;
}) {
  const { featureId } = useParams();// TODO: reimplement useAppSelector(selectedFeatureSelector);

  let helpText;
  if (modifying) {
    helpText =
      "Editing feature. Click along path to add vertices. Click away from feature to finish editing";
  } else if (featureId) {
    if (isGlobe) {
      helpText =
        "Selected feature. For editing capabilities switch to a 2D projection";
    } else {
      helpText = "Selected feature. To edit, click again on feature";
    }
  } else if (drawMode === "Point") {
    helpText = "Drawing Point. Click to place point";
  } else if (drawMode === "LineString" || drawMode === "Arc") {
    helpText =
      "Drawing Path. Click to add vertices, double-click when finished";
  } else if (drawMode === "Polygon") {
    helpText =
      "Drawing Polygon. Click to add vertices, double-click when finished";
  }
  if (!helpText) return null;
  return (
    <div className="absolute font-mono top-20 left-[400px] text-qmdark-50 text-xs bg-black/40 p-1">
      {helpText}
    </div>
  );
}